export default {
    validations: {
        required: "Это поле необходимо заполнить",
        //required: "Поле {property} обязательно",
        //email: "Field {attribute} is not a proper email address"
        between: "Должно быть от {min} до {max}",
        url: "Это поле должно быть url адресом (Пример: https://hl.ru)",
        fileSize: "Картинка должна не превышать {maxFileSizeInMB} мб.",
        maxLength: `Это поле должно быть не более {max} {word}`,
        minValue: `Значение этого поля должно быть больше или равно {min}`,
        maxValue: `Значение этого поля должно быть меньше или равно {max}`,
        selectRequired: `Это поле необходимо заполнить`,
    }
}
